import { useState, useEffect } from 'react';
import { Eye, ArrowLeft } from 'lucide-react';
import { api } from '../utils/api';

export default function ImpersonationBanner() {
  const [info, setInfo] = useState(null);

  useEffect(() => {
    const raw = localStorage.getItem('impersonating');
    if (raw) {
      try { setInfo(JSON.parse(raw)); } catch { /* ignore */ }
    }
  }, []);

  if (!info) return null;

  const handleReturn = async () => {
    const adminToken = localStorage.getItem('admin_token');
    if (adminToken) {
      // Must run BEFORE swapping localStorage: the request still carries the
      // impersonated user's cookie/Bearer token, which the backend uses to
      // verify this admin is allowed to switch back to adminToken.
      try {
        await api.post('/auth/sync-session-cookie', { session_token: adminToken });
      } catch {
        // Best-effort -- the localStorage/Bearer swap below still restores
        // admin access for most calls even if the cookie sync fails.
      }
      localStorage.setItem('session_token', adminToken);
      localStorage.removeItem('admin_token');
    }
    localStorage.removeItem('impersonating');
    window.location.href = '/admin';
  };

  return (
    <div
      className="w-full bg-amber-500 text-amber-950 px-3 sm:px-4 py-2 flex flex-wrap items-center justify-center gap-2 sm:gap-3 text-sm font-medium z-[9999] relative"
      data-testid="impersonation-banner"
    >
      <Eye className="w-4 h-4 shrink-0" />
      <span className="truncate">
        Viewing as <strong>{info.name}</strong>
        <span className="opacity-70 ml-1 hidden sm:inline">({info.email})</span>
        <span className="opacity-70 ml-1">&mdash; read-only</span>
      </span>
      <button
        onClick={handleReturn}
        className="inline-flex items-center gap-1.5 px-3 py-1 rounded-md bg-amber-950/15 hover:bg-amber-950/25 transition-colors text-amber-950 font-semibold text-xs shrink-0"
        data-testid="end-impersonation-btn"
      >
        <ArrowLeft className="w-3.5 h-3.5" />
        Return to Admin
      </button>
    </div>
  );
}
